module.exports = __webpack_public_path__ + "img/arrow-down-grey.ef473b30.svg";